import { ADD, ADD_MULTIPLE, REMOVE, UPDATE } from './constants';
import { BudgetAllocationMap } from './reducer';
import BudgetAllocation from './model';

export type AddAction = {
  type: typeof ADD;
  budgetAllocation: BudgetAllocation;
};
export const addAction = (budgetAllocation: BudgetAllocation): AddAction => ({
  type: ADD,
  budgetAllocation,
});

export type AddMultipleAction = {
  type: typeof ADD_MULTIPLE;
  budgetAllocations: BudgetAllocationMap;
};
export const addMultipleAction = (budgetAllocations: BudgetAllocationMap): AddMultipleAction => ({
  type: ADD_MULTIPLE,
  budgetAllocations,
});

export type UpdateAction = {
  type: typeof UPDATE;
  budgetAllocation: BudgetAllocation;
};
export const updateAction = (budgetAllocation: BudgetAllocation): UpdateAction => ({
  type: UPDATE,
  budgetAllocation,
});

export type RemoveAction = {
  type: typeof REMOVE;
  id: string;
};
export const removeAction = (id: string): RemoveAction => ({
  type: REMOVE,
  id,
});

export type BudgetAllocationActions = AddAction | AddMultipleAction | UpdateAction | RemoveAction;
